import $ from 'jquery';
import ko from 'knockout';

export function EditorPanelForm(data) {
    var self = this;
    self.approved = ko.observable(data['approved']);
    self.needApproval = ko.observable(data['needApproval']);
    self.lastApprovedDate = ko.observable(data['lastApprovedDate']);
    self.lastApprovedBy = ko.observable(data['lastApprovedBy']);
    self.prevApprovedBy = ko.observable(data['prevApprovedBy']);
    self.lastStateDate = ko.observable(data['lastStateDate']);
    self.lastStateBy = ko.observable(data['lastStateBy']);
    self.comment = ko.observable(data['comment']);
    self.user = ko.observable(data['user']);
    self.objId = ko.observable(data['objId']);
    self.contentType = ko.observable(data['contentType']);
    self.editType = ko.observable(data['editType']);

    self.isCommentVisible = ko.computed(function() {
        return !self.approved() && self.needApproval();
    });

    self.getColor = ko.computed(function() {
        var color = null;

        if (self.approved()) {
            if (self.needApproval()) color = 'green';
            else color = '#0085ff';
        } else color = 'red';

        return color;
    });

    self.getSecondColor = ko.computed(function() {
        var color = null;

        if (self.approved() && self.needApproval()) color = 'green';
        else color = 'black';

        return color;
    });

    self.getCommonState = ko.computed(function() {
        var state = '';

        if (self.approved()) {
            state = 'Отредактировано <i>(в отношении формата и общих правил)</i>';
            if (self.lastApprovedDate() || self.lastApprovedBy())
                state += ' ' + self.lastApprovedDate() + ' ' + self.lastApprovedBy();
        } else {
            state = 'Не отредактировано';
            if (self.lastApprovedDate()) state += ', но ранее редактировалось';
            state += ' <i>(в отношении формата и общих правил)</i>';
        }

        return state;
    });

    self.getLiteraryState = ko.computed(function() {
        var state = '';

        if (self.approved()) {
            state = 'Литературно отредактировано <i>(«Другие сведения» и текст верхнего блока)</i>';
            if (self.lastApprovedDate() || self.lastApprovedBy())
                state += ' ' + self.lastApprovedDate() + ' ' + self.lastApprovedBy();
        } else {
            if (self.needApproval()) {
                if (self.lastApprovedDate())
                    state =
                        'Нуждается в литературном редактировании, но ранее редактировалось <i>(«Другие сведения» и текст верхнего блока)</i>';
                else
                    state =
                        'Нуждается в литературном редактировании <i>(«Другие сведения» и текст верхнего блока)</i>';
            } else
                state =
                    'Не нуждается в литературном редактировании <i>(«Другие сведения» и текст верхнего блока отсутствуют)</i>';
        }

        return state;
    });

    self.getScientificState = ko.computed(function() {
        var state = '';

        if (self.approved()) {
            if (self.needApproval()) {
                state = 'Просмотрено научным редактором';
                if (self.lastApprovedDate() || self.lastApprovedBy())
                    state += ' ' + self.lastApprovedDate() + ' ' + self.lastApprovedBy();
            } else {
                state = 'Просмотр научного редактора не требуется';
                if (self.lastApprovedDate()) state += ' (ранее просматривалось)';
                if (self.lastStateDate() || self.lastStateBy())
                    state += ' ' + self.lastStateDate() + ' ' + self.lastStateBy();
            }
        } else {
            if (self.needApproval()) {
                state = 'Ожидает просмотра научным редактором';
                if (self.lastApprovedDate()) state += ' (ранее просматривалось)';
                if (self.lastStateDate() || self.lastStateBy())
                    state += ' ' + self.lastStateDate() + ' ' + self.lastStateBy();
            } else {
                state = 'Не просматривалось научным редактором';
                if (self.lastApprovedDate()) state += ' (ранее просматривалось)';
            }
        }

        return state;
    });

    self.getShortScientificState = ko.computed(function() {
        var state = '';

        if (self.approved()) {
            if (self.needApproval()) {
                state = 'Просмотрено научным редактором';
                if (self.lastApprovedDate() || self.lastApprovedBy())
                    state += ' ' + self.lastApprovedDate() + ' ' + self.lastApprovedBy();
            } else {
                state = 'Просмотр научного редактора не требуется';
                if (self.lastStateDate() || self.lastStateBy())
                    state += ' ' + self.lastStateDate() + ' ' + self.lastStateBy();
            }
        } else {
            if (self.needApproval()) {
                state = 'Ожидает просмотра научным редактором';
                if (self.lastStateDate() || self.lastStateBy())
                    state += ' ' + self.lastStateDate() + ' ' + self.lastStateBy();
            }
        }

        return state;
    });

    self.reloadStates = function(data) {
        self.lastApprovedDate(data['lastApprovedDate']);
        self.lastApprovedBy(data['lastApprovedBy']);
        self.prevApprovedBy(data['prevApprovedBy']);
        self.lastStateDate(data['lastStateDate']);
        self.lastStateBy(data['lastStateBy']);
        self.approved(data['approved']);
        if ('needApproval' in data) self.needApproval(data['needApproval']);
    };

    self.onEdit = function() {
        $.post('/cabinet/editor/approve/', {
            objId: self.objId(),
            contentType: self.contentType(),
            editType: self.editType(),
        })
            .done(function(data) {
                self.reloadStates(data);
            })
            .fail(function(data) {
                alert('В процессе сохранения информации о редактировании произошла ошибка.');
            });
    };

    self.onReset = function() {
        $.post('/cabinet/editor/reset/', {
            objId: self.objId(),
            contentType: self.contentType(),
            editType: self.editType(),
        })
            .done(function(data) {
                self.reloadStates(data);
            })
            .fail(function(data) {
                alert('В процессе сохранения информации о редактировании произошла ошибка.');
            });
    };

    self.onNeedApproval = function(data, event) {
        $.post('/cabinet/editor/need_approval/', {
            objId: self.objId(),
            contentType: self.contentType(),
            editType: self.editType(),
            needApproval: data,
        })
            .done(function(data) {
                self.reloadStates(data);
            })
            .fail(function() {
                alert('В процессе сохранения информации о редактировании произошла ошибка.');
            });
    };

    self.saveComment = function() {
        $.post('/cabinet/editor/save_comment/', {
            objId: self.objId(),
            contentType: self.contentType(),
            editType: self.editType(),
            comment: self.comment(),
        })
            .done(function(data) {})
            .fail(function(data) {
                alert('В процессе сохранения информации о редактировании произошла ошибка.');
            });
    };
}

export function EditorPanel() {
    if (!$('.u-person-page').length) {
        return;
    }

    $(function() {
        // $(document).tooltip({
        //     content: function () {
        //         return $(this).prop('title');
        //     }
        // });

        /*
         * Разрешает конфликт между bootstrap и jquery-ui
         */
        // $.fn.bootstrapBtn = $.fn.button.noConflict();
        // $.fn.bootstrapTooltip = $.fn.tooltip.noConflict();

        /*
         *  текст тултипа
         */
        var tooltipContent =
            '<p>Поставьте, пожалуйста, статус (нажмите кнопку) «Просьба просмотреть научному редактору», если, на Ваш взгляд,' +
            ' такой просмотр требуется: например, если вносилась информация о принадлежности к' +
            ' церковным расколам или церковным юрисдикциям, отличным от «РПЦ МП»; о снятии или лишении' +
            ' сана; если есть неуверенность в том, какой именно и был ли вообще священный сан, неясность' +
            ' в отношении наличия канонических препятствий (в частности, второй брак), негативная' +
            ' информация в отношении поведения на следствии (сотрудничество с органами, оговор других)' +
            ' или другая негативная информация или другая информация, о которой можно предположить,' +
            ' что лучше, чтобы ее оценил научный редактор. В этом случае желательно также заполнить' +
            ' поле «Комментарий», указав в нем, на что именно требуется обратить внимание научному редактору. ' +
            'Если заносилась простая биографическая информация, поставьте, пожалуйста, статус (нажмите кнопку)' +
            ' «Просмотр научного редактора не требуется». </p><p>Если не уверены, что просмотр научного редактора не требуется,' +
            ' то не ставьте никакой статус. </p><p>Если ошиблись, нажмите кнопку «Сброс» и проставьте статус,' +
            ' который считаете нужным, или не ставьте никакой статус.</p><span class="tooltip-close-btn glyphicon glyphicon-remove"></span>';

        $('.editor-panel__scientific-tooltip').tooltip({
            content: function() {
                return $(this).prop('title');
            },
            disabled: true,
            classes: {
                'ui-tooltip': 'highlight',
            },
            close: function(event, ui) {
                $(this).tooltip('disable');
            },
            position: {
                of: '.editor-panel__scientific-tooltip',
                at: 'center top',
                my: 'center bottom-5',
            },
        });

        $('.editor-panel__scientific-tooltip').on('click', function() {
            $(this)
                .tooltip('enable')
                .tooltip('open');
        });

        $('.editor-panel__scientific-tooltip').on({
            click: function() {
                $(this).tooltip({
                    items: '.editor-panel__scientific-tooltip',
                    content: tooltipContent,
                });
                $(this).tooltip('open');
            },
            mouseout: function(e) {
                e.stopImmediatePropagation();
                // $(this).tooltip({ items: ".editor-panel__scientific-tooltip", content: tooltipContent});
                // $(this).tooltip("open");
            },
        });

        $('body').on('click', '.tooltip-close-btn', function() {
            $('.editor-panel__scientific-tooltip')
                .tooltip('disable')
                .tooltip('close');
        });
    });
}
